import { createSlice } from '@reduxjs/toolkit'
import { NewClientLabelSchema } from '../types/NewClientLabel'
import { addNewClientLabel } from '../services/addNewClientLabel'
import { IClientLabel } from '../../../../entities/ClientLabel'

const newClientLabel: IClientLabel = {
	labelName: '',
	labelColor: ''
}

const initialState: NewClientLabelSchema = {
	clientLabel: newClientLabel,
	isLoading: false,
	error: ''
}

const newClientLabelSlice = createSlice({
	name: 'newClientLabel',
	initialState,
	reducers: {
		resetNewClientLabel: (state) => {
			state.clientLabel = newClientLabel
		},
		setLabelName: (state, action) => {
			state.clientLabel.labelName = action.payload
		},
		setLabelColor: (state, action) => {
			state.clientLabel.labelColor = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(addNewClientLabel.pending, (state) => {
				state.isLoading = true
				state.error = ''
			})
			.addCase(addNewClientLabel.fulfilled, (state) => {
				state.isLoading = false
			})
			.addCase(addNewClientLabel.rejected, (state, action) => {
				state.isLoading = false
				state.error = action.payload
			})
	}
})

export const { actions: newClientLabelActions } = newClientLabelSlice
export const { reducer: newClientLabelReducer } = newClientLabelSlice
